export default function({ isServer, store }) {
  if(isServer)
    return;
  store.commit('nav/activate', { top: null, page: null })
  store.commit('nav/close')
}
